import React, { Component } from "react"
import PropTypes from "prop-types"
import Sticky from "react-stickynode"
import SbEditable from "storyblok-react"
import Components from "../index"
import * as Icon from "react-feather"
import Shield from "../../assets/images/logos/hult-shield-white.svg"
import linkHandler from "../../helpers/storyblokLinkHandler"

class NavigationV2 extends Component {
  state = {
    displayNav: false,
    stickyTopValue: "",
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      window.addEventListener("window:resize", this.onWindowResize)
      this.onWindowResize()
    }
  }

  toggleNav = () => {
    if (document.documentElement.clientWidth <= 1023) {
      const { displayNav } = this.state

      this.setState({
        displayNav: !displayNav,
      })
    }
  }

  onWindowResize = () => {
    const { stickyTopValue } = this.state
    let newStickyTopValue = 0

    if (newStickyTopValue !== stickyTopValue)
      this.setState({ stickyTopValue: newStickyTopValue })
  }

  render() {
    const { displayNav } = this.state
    const { stickyTopValue } = this.state
    const { blok } = this.props
    return (
      <SbEditable content={blok}>
        <div
          className={`navigation-v2 ${displayNav ? "navigation-v2--open" : ""}`}
        >
          <Sticky activeClass="navigation-v2-stuck" top={stickyTopValue}>
            <div className="navigation-v2__container container">
              <header
                className="navigation-v2__header"
                onClick={this.toggleNav}
              >
                <div className="navigation-v2__branding">
                  <a
                    title="Hult"
                    href={"/"}
                    className="navigation-v2__branding-logo"
                  >
                    <img
                      alt=""
                      className="navigation-v2__branding-logo-img"
                      src={Shield}
                    />
                  </a>
                  <div className="navigation-v2__branding-copy">
                    {blok.breadcrumbLabel && (
                      <a
                        title={blok.breadcrumbLabel}
                        href={
                          blok.breadcrumbUrl.cached_url !== ""
                            ? linkHandler(blok.breadcrumbUrl)
                            : "#"
                        }
                        className="navigation-v2__branding-label"
                      >
                        <p className="navigation-v2__branding-label-text">
                          {blok.breadcrumbLabel}
                        </p>
                      </a>
                    )}
                    <p className="navigation-v2__branding-title">
                      {blok.title}
                    </p>
                  </div>
                </div>
                <div className="navigation-v2__icon" onClick={this.toggleNav}>
                  <Icon.ChevronDown />
                </div>
              </header>
              <nav className="navigation-v2__nav" onClick={this.toggleNav}>
                {blok.breadcrumbLabel && (
                  <a
                    title={blok.breadcrumbLabel}
                    href={
                      blok.breadcrumbUrl.cached_url !== ""
                        ? linkHandler(blok.breadcrumbUrl)
                        : "#"
                    }
                    className="navigation-v2__branding-label navigation-v2__branding-label--mobile"
                  >
                    <p className="navigation-v2__branding-label-text">
                      {blok.breadcrumbLabel} / {blok.title}
                    </p>
                  </a>
                )}
                {blok.links &&
                  blok.links.map((content) =>
                    React.createElement(Components(content.component), {
                      key: content._uid,
                      blok: content,
                      className: "navigation-v2__nav-link",
                    })
                  )}
                {blok.button && (
                  <div className="navigation-v2__nav-link navigation-v2__nav-link--button">
                    {blok.button &&
                      blok.button.map((content) =>
                        React.createElement(Components(content.component), {
                          key: content._uid,
                          blok: content,
                          className:
                            "navigation-v2__nav-button button-v2--thin",
                        })
                      )}
                  </div>
                )}
              </nav>
              {this.state.displayNav && (
                <div
                  className="navigation-v2__bg"
                  onClick={this.toggleNav}
                ></div>
              )}
            </div>
          </Sticky>
        </div>
      </SbEditable>
    )
  }
}

NavigationV2.defaultTypes = {
  anchorList: [],
  title: "",
}

NavigationV2.propTypes = {
  anchorList: PropTypes.arrayOf(
    PropTypes.shape({
      anchor: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  blok: PropTypes.shape({
    title: PropTypes.string,
    breadcrumbLabel: PropTypes.string,
    primary_button: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
}

export default NavigationV2
